export default {
    404: "Ops 404! La pagina non è disponibile.",
    admin_RemoveItem: "Rimuovi {v1}",
    admin_AddItem: "Aggiungi {v1}",
    admin_Admin: "Amministratore",
    admin_Owner: "Contatta",
    admin_Client: "Utente",
    admin_Votes: "Voti",
    admin_Profiles: "Profili",
    admin_Organizations: "Organizacioni",
    admin_showAllPlaces: "Mostra tutti i luoghi",
    admin_SaveRole: "Salva il ruolo",
    admin_deleteRole: "Cancellare il profilo {v1} {v2}?",
    admin_deleteVote: "Cancellare il voto per la domanda \"{v1}\"?",
    admin_deletePlace: "Cancellare la località \"{v1}\"?",
    admin_deleteOrganization: "Cancellare l'organizzazione \"{v1}\"?",
    admin_deletePlaceWarning: "** Tutti i voti relativi saranno rimossi.",
    admin_successMessageAddOwner: "Contatto aggiunto",
    admin_successMessageAddPlace: "Luogo aggiunto",
    admin_successMessageRemoveOwner: "Proprietario rimosso",
    admin_successMessageRemovePlace: "Luogo rimosso",
    admin_successMessageRemoveVote: "Voto rimosso",
    admin_successMessageRemoveOrganization: "Organizzazione rimossa",
    admin_successMessageSaveOrganization: "Organizzazione salvata",
    admin_successMessageChangeRole: "Ruolo cambiato",
    admin_Stickers: "Adesivi",
    admin_ChangeStatusToCancelled: "Cambiare lo stato in \"Cancellato\"?",
    admin_ChangeStatusToSent: "Cambiare lo stato in \"Inviato\"?",
    admin_ChangeStatusToCompleted: "Cambiare lo stato in \"Completato\"?",
    admin_adminVotesShowAll: "Mostra tutti i voti recenti",
    admin_searchByName: "Cerca per nome",
    admin_signInAs: "Accedi come: {v1}?",
    admin_ReturnToOriginalAccount: "Torna all conto originale: {v1}?",
    admin_closeAccountRequests: "Chiudere le richieste di conto",
    admin_landingQuestions: "Domande di atterraggio",
    admin_firstName: "Nome",
    admin_lastName: "Cognome",
    admin_contactEmail: "Email di Contatto",
    admin_phone: "Telefono",
    admin_success: "Successo",
    admin_userCreated: "È stato creato un nuovo utente",
    admin_sortBy: "Ordina per",
    admin_sortByName: "Nome",
    admin_sortByAdded: "Aggiunto",
    admin_sortByUpdated: "Aggiornato",
    admin_sortByEmail: "Email",
    admin_sortByCreated: "Creato",
    adminPanel: "Pannello amministrativo",
    admin_Add: "Aggiungi",
    admin_Places: "Luoghi",
    admin_UnQuestions: "Domande non collegate",
    admin_ChooseYourPlace: "Seleziona la tua posizione commerciale",
    admin_NothingFound: "Niente trovato",
    admin_Delete: "Cancella",
    admin_delete_image: "Vuoi eliminare le immagini?",
    admin_successImageDelete: "L'immagine è stata eliminata",
    Track_vote: "Per monitorare i tuoi voti, accedi:",
    Logout: "Uscire dal sito",
    Sync_status: "Stato della sincronizzazione",
    Success: "Successo",
    Error: "Errore",
    Back: "Indietro",
    No_votes: "Non hai ancora nessun voto",
    statusMessage: "Lavorando...",
    Save: "Salva",
    sign_in_to_connect: "Accedi per collegare questa domanda alla tua azienda",
    yes: "Si",
    no: "No",
    YourVotes: "I tuoi voti",
    OtherVotes: "I voti degli altri utenti",
    AirVotes: "AirVotes",
    Change: "Cambia",
    Submit: "Invia",
    Cancel: "Cancella",
    CancelRequest: "La richiesta è stata cancellata",
    ChangedYourMind: "Hai cambiato idea? Seleziona un altro voto!  Nota che la data/ora rimarrà la stessa.",
    NotConnectedPlaceToAirVote: "Questo posto non è attualmente collegato ad AirVote",
    From: "Da",
    To: "A",
    bflow_BusinesConnectQuestion: "Scegli la tua attività per collegare la domanda \"{v1}",
    bflow_BusinesConnectQuestionSuccess: "La domanda è stata collegata con successo",
    bflow_ChoosePlace: "Scegli un luogo per collegare la domanda \"{v1}",
    bflow_AddQuestionSuccess: "Domanda aggiunta",
    bflow_BecameOwnerPlace: "Fatto. Ora sei un contatto designato per \"{v1}\".",
    bflow_BecameOwnerPlaceConfirm: "Inserirti come contatto designato per \"{v1}\" ?",
    bflow_ConfirmConnectQuestionToPlace: "Aggiungere la domanda \"{v1}\" a questa posizione \"{v2}\" ?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Aggiungi la domanda \"{v1}\" alla posizione sottostante ?",
    bflow_ConnectedQuestion: "Domanda di collegamento...",
    bflow_finishBusinesFlow: "Vuoi uscire?",
    bi_Name: "Nome",
    bi_OfficialName: "Cognome",
    bi_ContactEmail: "Email di contatto",
    bi_Phone: "Telefono",
    bi_Password: "Password",
    bi_Edit: "Edta",
    bi_Address: "Indirizzo",
    bi_WebsiteUrl: "Url del sito web",
    bi_validation_OrganizationRequired: "Il nome dell'organizzazione è richiesto",
    bi_validation_Email: "Formato e-mail non corretto",
    bi_validation_Phone: "Formato del telefono non corretto",
    bi_validation_Website: "Formato del sito web non corretto",
    bi_first_Name: "Nome",
    bi_last_Name: "Cognome",
    bi_confirm_email: "Indirizzo email non confermato",
    bi_resend_email: "Reinvia l' email di autorizzazione",
    bi_resend_email_success: "L' email di conferma è stata reinviata con successo",
    bi_set_password: "Imposta la password",
    bi_change_password: "Cambia la tua password",
    bi_cancel_password: "Annulla il cambio di password",
    bi_current_password: "Password attuale",
    bi_new_password: "Nuova password",
    bi_retype_password: "Reinserire la nuova password",
    bi_save_password: "Salva la nuova password",
    bi_password_change_success: "Successo del cambio di password",
    own_use_w3w: "Geolocalizzazione -> Usa what3words",
    own_email_Confim: "Conferma il tuo indirizzo e-mail",
    own_anyConnectedPlace: "Nessun sito aziendale ancora collegato",
    own_myQuestions: "Le mie domande",
    own_createQuestion: "Creare una domanda",
    own_orderStickers: "Ordina gli smiley QR",
    own_selectRange: "Seleziona la gamma",
    own_today: "Oggi",
    own_last7days: "Ultimi 7 giorni",
    own_lastMonth: "Mese scorso",
    own_allTime: "Tutto il tempo",
    own_custom: "Personalizzato",
    own_Search: "Ricerca",
    own_showMore: "Mostra di più",
    own_showLess: "Mostra meno",
    own_Locations: "Posizionamenti",
    own_Questions: "Domande",
    own_Total: "Totale",
    own_Happy: "Felice",
    own_SoSo: "Cosi Cosi",
    own_Sad: "Triste",
    own_green: "Verde",
    own_yellow: "Giallo",
    own_red: "Rosso",
    own_EditQuestion: "Modifica domanda",
    own_DownloadPDF: "Generare QR smiley",
    own_DownloadPDFMobile: "Generare QR",
    own_OrderSticker: "Ordina adesivo QR",
    own_DeleteQuestion: "Cancellare la domanda",
    own_DownloadAndPrint: "Scaricare e stampare",
    own_OrderStickerFrom: "Ordina gli smiley QR da AirVote",
    own_OrderStickerDescription: "Gli smiley QR di AirVote sono stampati su vinile resistente alle intemperie. Consegnati entro 10-15 giorni. Lo stato dell'ordine è mostrato sul cruscotto",
    own_DeliveryAddress: "Inserisci l'indirizzo di consegna",
    own_RecipientName: "Nome del destinatario",
    own_RecipientPhone: "Telefono del destinatario",
    own_RecipientEmail: "Email del destinatario",
    own_Comment: "Commento",
    own_ShowZeroVotes: "Mostra zero voti",
    own_PlaceOrder: "Effettuare l'ordine",
    own_CreateNew: "Crea una nuova domanda su AirVote",
    own_EnterQuestion: "Inserisci qui la tua domanda AirVote",
    own_SpecifyLocation: "Specifica il posizionamento",
    own_DownloadPDF_Title: "Domanda aggiunta",
    own_DownloadPDF_Description: "Ora puoi scaricare un PDF della domanda. Per ordinarne uno da AirVote® usa la voce \"Genera Smileys QR\" nel menu della domanda",
    own_DownloadPDF_EditTitle: "Domanda aggiornata.",
    own_SureTODelete: "Cancellare la domanda?",
    own_DownloadSticker: "Scarica QR smileys PDF",
    own_StickerProportion: "Seleziona il layout degli smileys che corrisponde alle tue esigenze",
    own_PanelTextLeaflet: "Compatto",
    own_PanelTextBusiness: "Biglietto da visita",
    own_PanelTextExtended: "Standard",
    own_PanelSubtitleLeaflet: "Stampa come un piccolo biglietto da visita per i clienti o mettilo sul retro del tuo biglietto da visita",
    own_PanelSubtitleExtended: "Stampalo su un adesivo o un poster. Mettilo a portata di mano del cliente",
    own_PanelSubtitleBusiness: "Layout più compatto per i casi in cui hai bisogno di AirVote QR smiley da stampare e distribuire come biglietti da visita",
    own_AllVotesWillDeleted: "Tutti i voti per questa domanda AirVote® saranno cancellati",
    own_HasBeenDeleted: "Domanda cancellata",
    own_DontForgetCreate: "Non dimenticare di crearne una nuova!",
    own_OrderHasBeenPlaced: "Il tuo ordine è stato piazzato.",
    own_KeepTrack: "Lo stato dell'ordine apparirà sulla dashboard.",
    own_Manage: "Gestisci",
    own_Title: "Benvenuti nel pannello business di AirVote!",
    own_Business: "La tua ditta",
    own_Subitle: "Fornisci il nome della tua ditta per poter creare domande. Questo può essere cambiato in qualsiasi momento in seguito",
    own_Address: "Indirizzo",
    own_BusinessName: "Il nome della tua ditta",
    own_SaveBtn: "Salva e continua",
    own_SaveBtnWithQuestion: "Salva e ottieni i miei smiley QR",
    own_CanNotFind: "Non riesco a trovare la mia ditta",
    own_PleaseStartWriting: "Inizia a scrivere il nome della tua attività e sceglilo dal menu a tendina",
    own_filter_placeholder: "Inizia a digitare per filtrare",
    own_AssetId: "ID risorsa",
    AnalyticSettings: "Opzioni di analisi",
    AnalyticDescription: "Configurando questo si regola il modo in cui i dati vengono visualizzati nel cruscotto analitico",
    AnalyticIndex: "Indice analitico preferito",
    AnalyticWhatMean: "Cosa significa questo?",
    AnalyticWhatMeanIndex: "Perché l'indice è una buona idea?",
    AnalyticWhatMeanIndexDescription: "L'indice fornisce una misura oggettiva per tracciare le tendenze nel tempo e confrontare le prestazioni in diverse aree",
    AnalyticWhatMeanIndexValue: "",
    AnalyticIndexPromouterScore: "・Net Promoter Score: #\"voti felici\" * 100% + #\"voti così così\" * 0% - #\"voti tristi\" * 100%. Il punteggio più alto è 100. Il punteggio più basso è -100.",
    AnalyticIndexAirVoteScore: "Punteggio \"AirVote\": #\"happy votes\" * 100% + #\"so-so\" votes * 50%. Il punteggio più alto è 100. Il punteggio più basso è 0.",
    ThereIsAnError: "Si prega di inserire il valore corretto",
    StickerStatus: "Stato della etiquetta",
    Requested: "Richiesto",
    Sent: "Inviato",
    Cancelled: "Annullato",
    Close: "Chiudi",
    welcomeModalTitle: "Trova la tua azienda sulla mappa",
    welcomeModalSubtitle: "Usiamo i dati di Google per aiutarti a registrare la tua azienda in AirVote",
    welcomeModalSearchYouBusinass: "Cerca la tua azienda utilizzando l'input nella parte superiore dello schermo",
    welcomeModalPickOnMap: "O selezionala sulla mappa",
    welcomeModalNotOnGoogle: "L'azienda non è su Google? Problemi? Scrivici a",
    mapTipsSearch: "Cerca la tua azienda per nome",
    mapTipsPick: "O prendila sulla mappa",
    OK: "OK",
    Location: "Posizionamento",
    Question: "Domanda",
    companyManagement: "Gestione aziendale",
    sites: "Siti aziendali",
    site: "Sito",
    SitesDescription: "I siti aziendali sono diverse filiali o sedi della tua azienda. Ad ogni sito può essere assegnato uno o più site manager per co-amministrare il sistema AirVote del sito.",
    addNewSite: "Aggiungi sito",
    siteDetail: "Dettagli del sito",
    questionsAndAnalytics: "Domande e analisi",
    companyInformation: "Informazioni sull'azienda",
    companyManagers: "Manager dell'azienda",
    saveChanges: "Salva le modifiche",
    companyManagersDescription: "Puoi assegnare ad altri manager aziendali di co-amministrare il sistema AirVote della tua azienda.",
    Invite: "Invita",
    EnterEmailToAssignCompanyManager: "Inserisci l'email per assegnare un manager aziendale",
    enterSeveralEmailByComma: "Puoi inserire più email separate da una virgola",
    Pending: "In attesa",
    Accepted: "Accettato",
    Remove: "Rimuovi",
    ActiveManagers: "Manager attivi",
    NoOthersCompanyManagersAssigned: "Nessun altro manager aziendale assegnato",
    removeManager: "Rimuovi manager: {v1}?",
    all: "Tutti",
    editManagers: "Modifica i manager",
    assignManagers: "Assegna manager",
    viewAnalytic: "Visualizza l'analitica",
    deleteSite: "Elimina il sito",
    deleteSiteConfirm: "Elimina il sito: {v1}?",
    siteManagers: "Gestori del sito",
    SiteManagersNotAssigned: "Non assegnato",
    siteName: "Nome del sito",
    siteAddress: "Indirizzo del sito",
    Website: "Sito web",
    Email: "Email",
    Alias: "Alias",
    EditPhoto: "Modifica foto",
    SitePhoto: "Foto del sito",
    AirVoteSuggestsTitle: "AirVote suggerisce",
    SearchForQuestion: "Domande suggerite",
    UseQuestion: "Usa la domanda",
    ImagesSupportedParams: "Sono supportate le immagini in formato PNG e JPG. La dimensione massima della foto è di 5 Mb",
    UploadFile: "Caricare il file",
    RemovePhoto: "Rimuovi foto",
    ReturnBtn: "Indietro",
    RemovePhotoConfirm: "Rimuovere la foto del sito?",
    RemovePhotoSuccess: "Foto rimossa",
    WrongFormat: "Formato errato. Per favore usa PNG o JPG",
    PhotoOverweight: "La foto è più di {v1}Mb",
    cancelInvite: "Annulla l'invito: {v1}?",
    createSiteMap: "Crea un nuovo sito usando questo posto: {v1}?",
    chooseNewPlaceFrOrganization: "Per favore, scegli un nuovo luogo per la tua organizzazione.",
    MyBusinessIsMultipleSites: "La mia azienda ha più siti",
    goingToMultipleSitesMode: "Richiedi la modalità sito multiplo per la tua organizzazione?",
    by_questions: "Domande",
    by_sites: "Siti",
    by_locations: "Posizionamenti",
    groupBy: "Raggruppare per",
    Diagram: "Diagramma",
    ID: "ID",
    Filter: "Filtrare",
    Comments: "Commenti",
    ownLastVotes: "Ultimi voti",
    IndexAirvote: "Indice AirVote",
    TotalVotes: "Voti totali",
    Notifications: "Avvisi",
    CloseAccount: "Chiudere il mio account",
    DowngradeToClient: "Retrocedimi a cliente",
    sendAlertEvery: "Invia una notifica ogni",
    SendNotificationEach2: "voto(i)",
    IncludeSosoVotes: "Includere i voti così così",
    SMS: "SMS",
    Reports: "Segnalazioni",
    daily: "Quotidiano",
    weekly: "Settimanale",
    monthly: "Mensile",
    SendRequestToClose: "Chiudere il tuo account?",
    SendRequestToRestore: "Inviare la richiesta di ripristino dell'account?",
    RestoreAccount: "Ripristinare l'account",
    DowngradeProfileToClient: "Ridurre il profilo al ruolo di cliente?",
    ProfileSettings: "Impostazioni del profilo",
    savedSuccessfuly: "Impostazioni salvate con successo",
    Message: "Messaggio",
    NoData: "Nessun dato",
    Decline: "Rifiuta",
    Approve: "Approvare",
    DeclineRequest: "Rifiuta la richiesta di cancellazione dell'account?",
    ApproveRequest: "Approvare la richiesta di cancellazione dell'account?",
    MyPlaces: "I miei siti",
    EmptySiteTitle: "La tua azienda non ha nessun sito impostato. Aggiungine uno!",
    EmptySiteDescription: "I siti sono diverse filiali o uffici della tua azienda. Ad ogni sito può essere assegnato uno o più amministratori di sito. Un amministratore del sito può modificare i dettagli del sito e avere accesso all'analisi del sito",
    accountSettings: "Impostazioni dell'account",
    accountSettingsDescription: "Modificare i dati del tuo profilo, gestire le notifiche e i rapporti che ricevi",
    otherOptions: "Altre opzioni",
    UploadNewPhoto: "Caricare una nuova foto",
    receiveBadVotesViaSms: "Puoi ricevere notifiche sui voti tristi o così così via email o SMS",
    Threshold: "Soglia",
    SoSoVotes: "Voti così così",
    Channel: "Canale",
    DisableAllNotifications: "Disattivare tutte le notifiche",
    EnableAllNotifications: "Abilita tutte le notifiche",
    sendDetailedReportToEmail: "Possiamo inviare rapporti dettagliati alla tua email",
    Regularity: "Regolarità",
    nothingSelected: "Niente di selezionato",
    allNotificationsDisabled: "Tutte le notifiche disabilitate",
    createNewUser: "Creare un nuovo utente",
    exportRawData: "Esportare i dati grezzi",
    exportTo: "Esportare in",
    tab_Map: "Mappa",
    smileysMailTitle: "I tuoi smiley AirVote QR stanno arrivando!",
    smileysMailSubtitle: "Controlla {v1} per i tuoi QR smiley. Se non li ricevi entro pochi minuti, controlla la tua cartella Spam o",
    smileysMailDownload: "scarica qui",
    smileysMailChecklist: "Ora puoi accedere al tuo pannello aziendale. Usalo per:",
    smileysMailChecklistFirst: "Controllare i rapporti dei voti dei clienti in tempo reale",
    smileysMailChecklistSecond: "Creare e stampare domande aggiuntive",
    smileysMailChecklistThird: "Configurare avvisi in tempo reale sulle aree problematiche",
    smileysMailChecklistFourth: "Visualizzare le analisi avanzate",
    smileysMailChecklistMore: "...e molto di più!",
    smileysMailChecklistBtn: "Portami al mio pannello business ora",
    smileysMailChecklistBack: "Torna al sito web",
    signIn_enter: "Entrare, usando",
    signIn_or: "o",
    signIn_difficulties: "Hai difficoltà?",
    signIn_contact: "Contattaci a",
    question_suggestions_freq_title: "Usato di recente",
    signIn_signIn_title: "Accedi",
    signIn_signUp_title: "Iscriviti",
    signIn_enter_using_email: "o entra usando la tua email",
    signIn_email_hint: "Indirizzo e-mail",
    signIn_password_hint: "Password",
    signIn_signInBtn: "Accedi",
    signIn_forgotPass_btn: "Hai dimenticato la password?",
    signIn_noCreditReq: "Nessuna carta di credito richiesta",
    signIn_firstName_hint: "Il tuo nome",
    signIn_lastName_hint: "Cognome e nome",
    signIn_signUp_btn: "Iscriviti",
    signIn_useMedia: "O iscriviti usando i social media",
    signIn_agreeTo: "Sono d'accordo con AirVote",
    signIn_tAndC: "termini e condizioni",
    signIn_recoverPassword: "Recupera la tua password",
    signIn_recoverPassSubtitle: "Inserisci l'email utilizzata per accedere al tuo account",
    signIn_recoverPassContinue: "Continua",
    signIn_recoverPassBack: "Torna a Accedi",
    signIn_protected: "Questo sito è protetto da reCAPTCHA e dalla",
    signIn_privacyPolice: "Informativa sulla privacy",
    signIn_and: "E",
    signIn_Terms: "Condizioni di servizio",
    signIn_Login: "Accedi usando {v1}",
    signIn_Register: "Registrati usando {v1}",
    signIn_RegisterWithEmail: "Registrati con l'indirizzo e-mail",
    signIn_RegisterWithQuestion: "Prossimo: Informazioni sulla mia attività",
    signIn_SeparatorText: "O",
    signIn_TitleWithQuestion: "Registrati con AirVote per:",
    signIn_ChecklistFirst: "Ricevere i tuoi QR smiley via email",
    signIn_ChecklistSecond: "Accedere al tuo pannello aziendale per monitorare le risposte (voti)",
    auth_confirm_email_confirming: "Confermare la tua email 🔄",
    auth_confirm_email_confirmed: "Email confermata con successo ✅\nRedirezione al pannello business...",
    auth_confirm_email_already_confirm: "La tua email è già stata confermata",
    login_btn_link: "Accedi",
    login_btn_text: "al tuo pannello business",
    password_validation_min_length: "Lunghezza minima 6 caratteri",
    password_validation_uppercase: "Una lettera maiuscola",
    password_validation_lowercase: "Una lettera minuscola",
    loadPdfProgress: "Attendi che il tuo PDF venga generato 🔄",
    showManagePopupTitle: "Gestire le domande, scaricare gli smiley QR",
    showManagePopupSubtitle: "Benvenuto nel pannello degli affari di AirVote! Ogni blocco che vedi sullo schermo è una domanda che hai impostato. Usa l'icona per gestire le domande: modifica, rimuovi o scarica gli smiley QR in PDF",
    showFeedbackPopupTitle: "Inizia a ricevere feedback",
    showFeedbackPopupSubtitle: "Quando hai stampato i tuoi smiley QR, mettili in un posto che sia visibile al cliente. Ogni voto viene immediatamente visualizzato nel tuo pannello aziendale",
    showAlertsPopupTitle: "Imposta e ricevi avvisi",
    showAlertsPopupSubtitle: "Congratulazioni per aver ottenuto i tuoi primi voti! Sai che puoi ricevere notifiche su ogni voto sul tuo cellulare o sulla tua email? Usa la pagina del tuo profilo per impostare le regole di notifica",
    driverMainText: "Hai accesso solo attraverso la schermata dei voti. Scannerizza l'adesivo",
    helpCenterTitle: "Centro assistenza",
    orderBannerSubtitle: "Possiamo stampare le tue domande su un vinile impermeabile e spedirle ovunque nel mondo",
    orderBannerBtn: "Ordina adesivi",
    orderStickersBtn: "Ordina adesivi QR",
    orderPageBtn: "Cominciamo",
    orderSelectTitle: "Seleziona le domande che vorresti stampare",
    orderBusinessSite: "Sito aziendale",
    orderBusinessPlacement: "Posizionamento",
    orderTotal: "Totale ordine",
    orderDelivery: "Consegna",
    orderDeliveryText: "Gratis",
    orderFormTitle: "Completa il tuo ordine",
    orderFormSubtitle: "Il tempo di consegna approssimativo è di 10-15 giorni",
    orderShippingTitle: "Spedizione fuori dagli Stati Uniti o dall'Europa",
    orderShippingSubtitle: "Contatta AirVote per ottenere il preventivo dell'ordine comprensivo di tutte le spese di spedizione e doganali",
    orderQuote: "Ottenere un preventivo",
    orderSuccessPayment: "Il tuo ordine è stato creato con successo. Ti contatteremo presto e ti forniremo un preventivo",
    orderSuccessPayPal: "Il suo ordine è stato pagato con successo. Sarai avvisato quando l'ordine sarà spedito",
    orderCountryLabel: "Paese",
    orderStickerSizeLabel: "Dimensione dell'adesivo",
    orderBtnToDashboard: "Vai al cruscotto",
    unsubscribeBtn: "Cancella l'iscrizione a",
    unsubscribeSaveBtn: "Aggiorna le impostazioni",
    unsubscribePopupText: "Cancella l'iscrizione ora",
    orderShippingBlockTitle: "Informazioni sulla consegna",
    title_404: "La pagina che stai cercando di raggiungere non è disponibile",
    btn_404: "Torna indietro",
    dataReportPopup: "Non ci sono dati. Per favore cambia i tuoi filtri o scegli un intervallo di date diverso",
    dataReportPopupMobileXLSX: "Questo file contiene solo i dati di voto. Per l'analisi dettagliata dei voti e i grafici, si prega di utilizzare AirVote dashboard su PC o Mac",
    manageScreenQuestion: "Domanda",
    manageScreenLocation: "Descrizione della posizione",
    manageSetGeolocation: "Imposta la geolocalizzazione",
    manageSetAsset: "Attività #",
    manageGeolocation: "Geolocalizzazione",
    manageUpdateBtn: "Aggiorna",
    manageLatitude: "Latitudine",
    manageLongitude: "Longitudine",
    manageGPSAccuracy: "Precisione GPS {v1}m",
    manageGPSLocation: "Posizione GPS",
    manageGPSAllowText: "Consenti ad air-vote.com di recuperare i dati della posizione GPS dal tuo telefono",
    manageGPSAllowSubtitle: "* lo useremo solo quando visiterai questa pagina per aggiornare la geolocalizzazione della domanda",
    manageGPSPopupLongDistance: "Le tue attuali coordinate GPS sono lontane dal precedente posizionamento dell'adesivo {v1}m",
    manageGPSPopupBadAccuracyAndLongDistance: "Le tue attuali coordinate GPS sono lontane dal precedente posizionamento dell'adesivo {v1}m e hanno una scarsa precisione {v2}m",
    manageGPSPopupBadAccuracy: "Le tue attuali coordinate GPS hanno una scarsa precisione ({v1}m)",
    manageGPSPopupSureNewCoords: "Sei sicuro di usare le nuove coordinate?",
    manageGPSPopupUseNewCoordsBtn: "Usa le nuove coordinate",
    manageGPSPopupChangeManuallyBtn: "Cambia manualmente",
    manageMapBtn: "Usa questa posizione",
    manageSaved: "Salvato",
    manageCopiedToClipboard: "Copiato negli appunti",
    manageGPSUnableToFetchMsg: "Non siamo riusciti a recuperare la posizione gps. Si prega di riprovare",
    manageGPSUnavailable: "La posizione GPS non è disponibile. Per favore riprova o contatta il nostro team di supporto",
    manage_back_to_yard: "Back to yard",
    w3wTitle: "Un modo semplice per descrivere la posizione in qualsiasi parte del mondo",
    w3wLearnMore: "Per saperne di più",
    unassignedQuestion: "Le domande non assegnate",
    own_votesNotFound: "Sembra che tu non abbia voti recenti 😔\n\nPer favore assicurati che i tuoi AirVote Stickers siano ancora al loro posto e funzionino correttamente",
    own_votesQuestion: "Domanda:",
    own_votesPlacement: "Posizionamento:",
    own_votesPriorVotes: "Voti precedenti dell'utente:",
    own_votesUser: "Utente:",
    own_votesComment: "Commento:",
    own_votesContactInfo: 'Informazioni di contatto:',
    bulkPlacement: "Modifica del posizionamento in blocco",
    bulkPlacementPopupSavedQuestions: "Domande selezionate",
    bulkPlacementPopupSelectAll: "Seleziona tutti",
    bulkSuccessfulPlaceEdit: "Il posizionamento è stato modificato con successo",
    showAllVotes: "Mostra tutti i voti recenti",
    bulkInputPlaceHolder: "Nuovo posizionamento",
    copy: "Copia",
    telegramPopupGroup: "Aggiungi Bot al gruppo",
    telegramPopupPrivate: "Aggiungi Bot alla chat privata",
    telegramPopupTitle: "Il tuo Hash",
    setupTelegramBtn: "Imposta il Bot di Telegram",
    telegramHashAvailable: "L'hash attuale è disponibile per 1 ora",
    moreOptiosPopuoTitle: "Più opzioni",
    emailSignature: 'Comunicazioni elettroniche',
    emailSignatureSubtitle: "Copia/incolla le emoticon nelle tue e-mail, fatture elettroniche o per qualsiasi presentazione online",
    emailSignatureTitle: 'Come funziona AirVote per te finora?',
    emailSignatureClick: 'Clicca su uno smiley per lasciare un feedback',
    emailSignatureCopyLink: 'Copia link',
    singleEmailSignaturePageTitle: 'Aggiungi AirVote E-Smiley alle tue comunicazioni',
    copied: 'copiato',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Registro di servizio',
    airLeadSubmittedBy: 'Inviato da:',
    airLeadChooseDriver: 'scegli autista',
    airLeadCompanyName: 'Nome della ditta',
    airLeadSiteType: 'Tipo di sito',
    airLeadOpportunity: 'Opportunità',
    airLeadCustomer: 'Cliente',
    airLeadAdditionalNotes: 'Note aggiuntive',
    airLeadMoreService: 'Più servizio',
    airLeadMoreUnits: 'Più unità',
    airLeadSink: 'Un lavello',
    airLeadCallThem: 'Per chiamarli',
    airLeadSubmitALead: 'Invia un vantaggio',
    airLeadHideLeads: 'Nascondi lead chiusi',
    airLeadShowAllLeads: 'Mostra tutti i lead',
    airLeadDashboardDate: 'Data',
    airLeadDashboardType: 'Tipo',
    airLeadDashboardStatus: 'Stato',
    airLeadDashboardStatusNotes: 'Note di stato',
    airLeadDashboardLastActionDate: 'Data dell`ultima azione',
    airLeadDashboardActionBy: 'Azione di',
    airLeadDashboardSalesFollowUp: 'Follow-up delle vendite',
    airLeadDashboardNotClosed: 'Non chiuso',
    airLeadDashboardClosedWon: 'Chiuso/Vinto',
    airLeadDashboardNotQualified: 'Non qualificato',
    airLeadDashboardCommission: 'Commissione',
    airLeadDashboardNotLeadsFound: 'Nessun lead trovato',
    airLeadDashboardRefresh: 'Ricaricare',
    airLeadInfoPopupDriver: 'Autista',
    airLeadInfoPopupNotes: 'Appunti',
    airLeadInfoPopupLocation: 'Posizione',
    airLeadInfoPopupViewOnMap: 'Visualizza sulla mappa',
    airLeadInfoPopupServices: 'Servizi',
    airLeadStatusAndCommissionError: 'Inserisci le note di stato e la commissione per chiudere un lead',
    airLeadStatusNotesError: 'Inserisci le note di stato per chiudere un lead',
    airLeadNewCustomerLead: 'Nuovo cliente principale',
    airLeadExistingCustomer: 'Lead cliente esistente',
    airLeadPleaseChooseDriver: 'Si prega di scegliere un driver',
    airLeadPleaseCompanyInfo: 'Si prega di inserire le informazioni sull`azienda',
    airLeadPleaseCustomerInfo: 'Si prega di inserire le informazioni del cliente',
    airLeadGoodLack: 'Buona fortuna per il tuo vantaggio! \nGrazie per aver contribuito a portare nuovi clienti!',
    airLeadCommission: 'La commissione dovrebbe essere maggiore di 0',
    airLeadNumberShouldContains: 'Il numero deve contenere meno di 3 cifre',
    sldPlaceGuid: 'Posiziona la guida',
    sldOrganizationGuid: 'Guida all\'organizzazione',
    sldGetPlaceConfig: 'Ricarica la configurazione',
    sldEnableDetails: 'Abilita i dettagli di livello 2D',
    sldBasicConfig: 'Configurazione di base',
    sldScreenTitle: 'Titolo della schermata',
    sldScreenSubTitle: 'Sottotitolo',
    sldScreenBackground: 'Sfondo dello schermo:',
    sldMaxCount: 'Conteggio massimo di elementi selezionati',
    sldEnterForUnlimited: 'Inserisci 0 per illimitato',
    sldShowComment: 'Mostra sempre il commento',
    sldBlocks: 'Blocchi:',
    sldText: 'Testo',
    sldGreenScreen: 'Schermo verde',
    sldYellowScreen: 'Schermo giallo',
    sldRedScreen: 'Schermo rosso',
    sldOverrideSettings: 'Sostituisci le impostazioni di base',
    sldOverrideBlocks: 'Sostituisci i blocchi di base',
    sldSecondLevelDetails: 'Dettagli di secondo livello',
    configMissingMsg: 'Manca la configurazione, vuoi abilitarla',
    sldTakeFromPlace: 'Prendere dal luogo',
    sldChooseAnIcon: 'Scegliere un\'icona',
    sldEditIcon: 'Icona di modifica',
    sldUploadIcon: 'Caricare una nuova icona',
    sldIconTag: 'Tag icona',
    sldPleaseFillInput: 'Compilare il campo',
    sldDefaultText: 'Testo predefinito',
    sldChooseIcon: 'Scegliere l\'icona',
    sldSaveAndAddMore: 'Salvare e aggiungere altro',
    sldAddIcon: 'Aggiungi icona',
    sldAreYouSure: "Dovete cancellare questa immagine?",
    enableServiceLog: 'Abilita la configurazione del registro di servizio',
    serviceLogRequirePin: 'Richiedere il pin',
    serviceLogInfoPopup: 'Mostra il popup delle informazioni sul registro di servizio',
    serviceLogPlacementEdit : 'Modifica del posizionamento della mostra',
    commentViewOnMap: 'Visualizza sulla mappa',
    sldTagInUseErrorTitle: "Impossibile eseguire questa azione. Il tag è attualmente in uso:",
    tab_AssetsMap: "Mappa dei bagni",
    settings_checkbox_GoogleReviewAlerts: "Google review alerts"
}
